import styles from './styles.module.scss';
import { FC, useState, useEffect } from 'react';
import { ButtonWithIcon } from 'shared';

type LookupFieldProps = {
  regNo?: string;
  onLookup: (regNo: string) => void;
  isLoading?: boolean;
};

export const LookupField: FC<LookupFieldProps> = ({ regNo: initialRegNo, onLookup, isLoading }) => {
  const [regNo, setRegNo] = useState(initialRegNo ?? '');

  useEffect(() => {
    setRegNo(initialRegNo ?? '');
  }, [initialRegNo]);

  const handleLookup = () => {
    if (regNo.trim()) {
      onLookup(regNo.trim());
    }
  };

  return (
    <div className={styles.lookupContainer}>
      <div className="col">
        <label className="form-label fs-6">Reg No</label>
        <input
          maxLength={250}
          className="form-control form-control-sm form-control-solid mb-5"
          type="text"
          placeholder="Reg No"
          value={regNo}
          onChange={(e) => setRegNo(e.target.value)}
        />
      </div>
      <div className={styles.lookupButton}>
        <ButtonWithIcon
          iconPath="/media/icons/custom/zoom_1.svg"
          onClick={handleLookup}
          disabled={!regNo.trim()}
          isLoading={isLoading}
        >
          Look Up
        </ButtonWithIcon>
      </div>
    </div>
  );
};
